export const actionTypes = {
    OPEN_ARENA_DIALOG: 'OPEN_ARENA_DIALOG',
    CLOSE_ARENA_DIALOG: 'CLOSE_ARENA_DIALOG',
};

export const OpenArenaDialog = (payload) => ({
    type: actionTypes.OPEN_ARENA_DIALOG,
    payload,
});

export const CloseArenaDialog = () => ({
    type: actionTypes.CLOSE_ARENA_DIALOG,
});
